import { API_CALL } from '../../../../../middleware/api';
import { WIDGET_GET_PATIENTS_WITH_NO_READINGS } from './constants';

export const actions = {
  getPatientsWithNoReadings: (days, orgId) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/patients/list',
      params: { limit: 1, noReadingsSince: days, status: 'activated', orgId },
    },
    type: WIDGET_GET_PATIENTS_WITH_NO_READINGS,
  }),
};
